// eventBus.js
export const eventBus = {
  dispatch(event, data) {
    window.dispatchEvent(new CustomEvent(event, { detail: data }))
  },
  subscribe(event, callback) {
    window.addEventListener(event, callback)
  },
  unsubscribe(event, callback) {
    window.removeEventListener(event, callback)
  },
}
